import Breadcrumb from "Components/UI/Breadcrumb";
import Spinners from "Components/UI/Spinner";
import PaginatedTable from "Components/Tables/PaginatedTable";
import DeleteModal from "Components/Modals/DeleteModal";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Container } from "reactstrap";
import { getCategories, deleteCategory } from "helpers/API Calls/Operations/category";
import useTableFilters from "helpers/hooks/useTableFilters";
import { Link } from "react-router-dom";
import convertDateFormat from "Components/Date/DateFormat";
import { generateQueryParams } from "helpers/queryParams";

const head = [
  {id: 1, name: "#", isSortable: true, key: "id"},
  {id: 2, name: "Category", isSortable: true, key: "category_name"},
  {id: 8, name: "Addon", isSortable: true, key: "is_addon"},
  {id: 3, name: "Sequence", isSortable: true, key: "sequence"},
  {id: 4, name: "Status", isSortable: true, key: "status"},
  {id: 5, name: "Created", isSortable: true, key: "created_at"},
  {id: 6, name: "Updated", isSortable: true, key: "updated_at"},
  {id: 7, name: "Actions"}
];

function Categories() {

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [categories, setCategories] = useState<any[]>([]);
  const [pagination, setPagination] = useState<any>({current_page: 1, last_page: 1, per_page: 10, total: 0});

  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [categoryToDelete, setCategoryToDelete] = useState<any>(null);
  
  const { filters, updateFilter } = useTableFilters();
  
  const fetchCategories = async () => {
    setIsLoading(true);
    const response = await getCategories(generateQueryParams(filters));
    if (response.success) {
      setCategories(response.data.items);
      setPagination(response.data.pagination);
    }
    setIsLoading(false);
  }

  useEffect(() => {
    fetchCategories();
  }, [filters]);

  const handleDeleteClick = (item) => {
    setCategoryToDelete(item);
    setDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    if (categoryToDelete) {
      const response = await deleteCategory(categoryToDelete.id);
      if (response.success) {
        setDeleteModal(false);
        setCategoryToDelete(null);
        fetchCategories();
      }
    }
  };

  const onCloseClick = () => {
    setDeleteModal(false);
    setCategoryToDelete(null);
  };

  return (
    <>
    <div className="page-content">
      <Container fluid >
        <Breadcrumb items={[{ label: "Categories", link: "/categories" }]} />
        {isLoading ? <div className="position-relative vh-100"><Spinners/></div>
        :
        <>
          <Card>
            <CardBody>
              <PaginatedTable
                tableHead={head}
                pagination={pagination}
                isAddButton={true}
                buttonText="Add New Category"
                to="/categories/create"
                // hasFilter={false}
                updateFilter={updateFilter}
                filters={filters}
              > 
                {categories.length > 0 && categories.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.category_name}</td>
                    <td>
                      <span className={`badge badge-soft-${item.is_addon ? 'success' : 'secondary'}`}>
                        {item.is_addon ? 'Yes' : 'No'}
                      </span>
                    </td>
                    <td>{item.sequence}</td>
                    <td>
                      <span className={`badge badge-soft-${item.status === 'active' ? 'success' : 'danger'}`}>
                        {item?.status?.charAt(0).toUpperCase() + item?.status?.slice(1)}
                      </span>
                    </td>
                    <td>{convertDateFormat(item.created_at)}</td>
                    <td>{convertDateFormat(item.updated_at)}</td>
                    <td>
                      <div>
                        {/* <a href={item?.link} className="btn btn-warning btn-sm me-1"><i className="bx bx-eye"/></a> */}
                        <Link to={`${item.id}/edit`} className="btn btn-primary btn-sm me-1"><i className="bx bx-pencil"/></Link>
                        <button className="btn btn-danger btn-sm" onClick={() => handleDeleteClick(item)}><i className="mdi mdi-trash-can-outline"></i></button>
                      </div>
                    </td>
                  </tr>))
                }
                {!isLoading && categories.length === 0 && <tr className="text-center"><td colSpan={head.length} className="text-danger">No Data Found</td></tr>}
              </PaginatedTable>
            </CardBody>
          </Card>
        </>}
      </Container>
    </div>
    {deleteModal && <DeleteModal
      show={deleteModal}
      onDeleteClick={handleDeleteConfirm}
      onCloseClick={onCloseClick}
      message={`${categoryToDelete?.category_name} category?`}
    />}
    </>
  );
}

export default Categories;
